// extracted by mini-css-extract-plugin
export default {"sideItem":"dNATPdpb_S442DZFg3rL","linkToItem":"Zmu9bEeaI26V5RRjDroi","icon":"clOxhSRnxRl1p20n7SfQ","optionSelected":"g6h1Fy_CvrOJrpiB1ggM"};